var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFileCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 22,
  fill: "none",
  viewBox: "0 0 24 22"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 24,
  height: 22,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h24v22H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D4D4D8",
  d: "M19 17.416H8q-.824 0-1.412-.538Q6 16.338 6 15.583V2.749q0-.756.588-1.294A2.02 2.02 0 0 1 8 .916h7l6 5.5v9.167q0 .755-.587 1.295a2.02 2.02 0 0 1-1.413.538M14 7.333V2.749H8v12.834h11v-8.25zM4 21.083q-.824 0-1.412-.539Q2 20.006 2 19.25V6.416h2v12.833h11v1.834z"
}))));
export { SvgFileCopy as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyNCAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb25zL2ZpbGVfY29weSI+CjxtYXNrIGlkPSJtYXNrMF8zMzYwXzU5NzIiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyMiI+CjxyZWN0IGlkPSJCb3VuZGluZyBib3giIHdpZHRoPSIyNCIgaGVpZ2h0PSIyMiIgZmlsbD0iI0Q5RDlEOSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMzM2MF81OTcyKSI+CjxwYXRoIGlkPSJmaWxlX2NvcHkiIGQ9Ik0xOSAxNy40MTZIOEM3LjQ1IDE3LjQxNiA2Ljk3OTE3IDE3LjIzNjUgNi41ODc1IDE2Ljg3NzVDNi4xOTU4MyAxNi41MTg0IDYgMTYuMDg2OSA2IDE1LjU4MjdWMi43NDkzNUM2IDIuMjQ1MTggNi4xOTU4MyAxLjgxMzU5IDYuNTg3NSAxLjQ1NDU2QzYuOTc5MTcgMS4wOTU1MyA3LjQ1IDAuOTE2MDE2IDggMC45MTYwMTZIMTVMMjEgNi40MTYwMlYxNS41ODI3QzIxIDE2LjA4NjkgMjAuODA0MiAxNi41MTg0IDIwLjQxMjUgMTYuODc3NUMyMC4wMjA4IDE3LjIzNjUgMTkuNTUgMTcuNDE2IDE5IDE3LjQxNlpNMTQgNy4zMzI2OFYyLjc0OTM1SDhWMTUuNTgyN0gxOVY3LjMzMjY4SDE0Wk00IDIxLjA4MjdDMy40NSAyMS4wODI3IDIuOTc5MTcgMjAuOTAzMiAyLjU4NzUgMjAuNTQ0MUMyLjE5NTgzIDIwLjE4NTEgMiAxOS43NTM1IDIgMTkuMjQ5NFY2LjQxNjAySDRWMTkuMjQ5NEgxNVYyMS4wODI3SDRaIiBmaWxsPSIjRDRENEQ4Ii8+CjwvZz4KPC9nPgo8L3N2Zz4K";